import { AxiosResponse } from "axios"
import * as ApiUrls from "./ApiUrl.VAExcelExport" ;
import { axiosCoreInstance } from "../AxiosCoreInterceptor";
import { axiosInstance } from "../AxiosInterceptor";
import { VAExcelExportsHistory } from "../../Model/Dto/VerificationAgency/VaExcelExports";

export const VAExcelExportService = {
    ExportVAPack: (exportRequest: FormData) : Promise<AxiosResponse<any>> =>
        axiosCoreInstance.post(ApiUrls.ExportVAPack, exportRequest, {
            headers: {"Content-Type": "multipart/form-data"}
    }),

    GetVAPack: (scorecardId : string) : Promise<AxiosResponse<ArrayBuffer>> =>
        axiosInstance.get(`${ApiUrls.GetVAPack}?ScorecardId=${scorecardId}`, {
            responseType: "arraybuffer"
    }),

    SearchVAExcelExports: (request: VAExcelExportsHistory.SearchRequest) : Promise<AxiosResponse<VAExcelExportsHistory.SearchResponse>> => 
        axiosCoreInstance.post(`${ApiUrls.SearchVAExcelExports}`, request),

    DownloadVAExcelExport: (id: number) : Promise<AxiosResponse<any>> =>
        axiosCoreInstance.get(`${ApiUrls.DownloadVAExcelExport}?id=${id}`),

    CheckVAExportInProgress: (scorecardId: string) : Promise<AxiosResponse<boolean>> =>
        axiosCoreInstance.get(`${ApiUrls.CheckVAExportInProgress}?ScorecardId=${scorecardId}`),
}